export default __webpack_public_path__ + "afcd2067f448d45330f2fb86e413c8db.png";